import {
    HttpResponse,
    MachineComponentStationModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class MachineComponentStationsDataService implements CrudService<MachineComponentStationModel, MachineComponentStationModel> {
    getAll(query: CrudDataQuery<MachineComponentStationModel>): Promise<CrudEnumerableResponse<MachineComponentStationModel>> {
        return ApiService.api.getMachineComponentStationBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<MachineComponentStationModel>): Promise<CrudEnumerableResponse<MachineComponentStationModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<MachineComponentStationModel>> {
        return ApiService.api.getMachineComponentStationById(id, params);
    }

    create(item: MachineComponentStationModel, params?: RequestParams): Promise<CrudResponse<MachineComponentStationModel>> {
        return ApiService.api.insertMachineComponentStation(item, params);
    }

    update(item: MachineComponentStationModel, params?: RequestParams): Promise<MachineComponentStationModel> {
        return ApiService.api.updateMachineComponentStation(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<MachineComponentStationModel> {
        return ApiService.api.patchMachineComponentStation(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<MachineComponentStationModel>): Promise<CrudEnumerableResponse<MachineComponentStationModel>> {
        return ApiService.api.deleteMachineComponentStations(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationMachineComponentStation(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<MachineComponentStationModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: MachineComponentStationModel, params?: RequestParams): Promise<CrudResponse<MachineComponentStationModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getMachineComponentStationGroupped(query, params);
    }

}

